import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyCz-SR_b_8Rn41e9xr1i7iQcwJaCR9DFJ0",
    authDomain: "fakeinsta-1.firebaseapp.com",
    databaseURL: "https://fakeinsta-1.firebaseio.com",
    projectId: "fakeinsta-1",
    storageBucket: "fakeinsta-1.appspot.com",
    messagingSenderId: "594162142000",
    appId: "1:594162142000:web:f4422fb869f95d402b16f5",
    measurementId: "G-6RKGERQE7F"
  };
  
firebase.initializeApp(config);

export default firebase;